<!-- Profile strip -->
<div class="profiles-strip">
  <!-- Strip header: search left, action right -->
  <div class="strip-header">
    <div class="search-wrap">
      @if (typeaheadData.length > 0) {
        <mc-typeahead
          fit="small"
          label="Search by tag or vendor code"
          placeholder="Example: No Eeir, 1VD, 3JK"
          [data]="typeaheadData"
          highlight
          debounce="0"
          clearbutton
          (input)="onSearch($event)"
          (optionselected)="onOptionSelected($event)"
          (clearbuttonclick)="clearSearch()"></mc-typeahead>
      }
    </div>
  </div>

  <!-- Profile cards -->
  <div class="profile-cards">
    @for (setting of filteredProfiles; track setting.id) {
      <button
        class="profile-card"
        [class.profile-card--selected]="isSelected(setting.id)"
        (click)="toggleProfile(setting.id)"
        type="button">
        <div class="profile-card-inner">
          <div class="profile-tags-row">
            <div class="profile-tags-list">
              @if (setting.id === DUMMY_ID) {
                <span class="mds-body mds-neutral--default__on-background-color">New copy</span>
              } @else {
                @for (tag of setting.tags; track tag) {
                  <mc-tag [label]="tag" appearance="neutral"></mc-tag>
                }
              }
            </div>
            @if (setting.id !== DUMMY_ID) {
              <span class="shop-count-pill">{{ setting.shopCount }}</span>
            }
          </div>
        </div>
      </button>
    } @empty {
      <p class="mds-body mds-neutral--default__on-background-color">
        {{ isLoading ? 'Loading...' : 'No profiles match your search.' }}
      </p>
    }
  </div>
</div>
